import React from 'react';

const Test = () => {
    return (
        <div>
            <h1>ali</h1>
        </div>
    );
}

export default Test;
